import { cn } from '@repo/lib/cn';
import { Download } from 'lucide-react';
import { ComponentProps, useMemo } from 'react';

import type { MediaViewerFile } from '@/components/features/media/MediaViewer';

import { Button } from '@/components/ui/button';
import { Dialog, DialogBody, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { VideoPlayer } from '@/components/ui/media-player';
import { getFileUrl } from '@/utils/file';

export default function MediaVideoViewer(mediaViewerFile: MediaViewerFile) {
  const { file, open, onOpenChange } = mediaViewerFile;
  const isFilesInstance: boolean = 'id' in file;

  const fileURL = useMemo<string>(() => {
    if ('id' in file) {
      return getFileUrl(file.id);
    } else if (file instanceof File) {
      return URL.createObjectURL(file);
    }
    return '';
  }, [file]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogBody>
          <DialogHeader>
            <DialogTitle>{file.name}</DialogTitle>
            <DialogDescription className={'sr-only'}>{file.name} - podgląd</DialogDescription>
          </DialogHeader>
          <MediaVideoViewerContent src={fileURL} />
        </DialogBody>
        <DialogFooter>
          {isFilesInstance ? (
            <a href={fileURL} download target="_self">
              <Button variant={'ghost'}>
                <Download />
              </Button>
            </a>
          ) : null}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export function MediaVideoViewerContent(mediaVideoViewerContentProps: ComponentProps<typeof VideoPlayer>) {
  const { src, size = 'lg', className, ...props } = mediaVideoViewerContentProps;

  return <VideoPlayer size={size} src={src} className={cn('mx-auto aspect-video rounded-none', className)} {...props} />;
}
